import React from 'react';
import ContentLoader from 'react-content-loader';
import cx from 'classnames';

import { GRID_VIEW, LIST_VIEW } from '../../../constants/viewTypes';
import { GRID_PLACEHOLDER, LIST_PLACEHOLDER } from '../styles/placeholder';
import '../styles/_placeholder.scss';






const X_COORD_ADJUST = 50;

function getCalculatedXCoord(coord, { shouldAdjust }) {
  return `${shouldAdjust ? coord + X_COORD_ADJUST : coord}`;
}

const Placeholder = ({ view, hasBulkActions }) =>
<>
    {view === 'grid' ?
  <ContentLoader
    height={205}
    width={205}
    speed={1.5}
    primaryColor="rgb(232, 236, 240, 0.75)"
    secondaryColor="rgb(232, 236, 240, 0.2)"
    className={cx('grid-placeholder', GRID_PLACEHOLDER)}>

        <rect x="20" y="20" rx="0" ry="0" width="90" height="90" />
        <rect x="120" y="23" rx="4" ry="4" width="63" height="10" />
        <rect x="120" y="43" rx="4" ry="4" width="45" height="10" />
        <rect x="120" y="63" rx="3" ry="3" width="50" height="10" />
        <rect x="120" y="83" rx="4" ry="4" width="63" height="10" />
        <rect x="20" y="133" rx="3" ry="3" width="150" height="10" />
        <rect x="20" y="153" rx="3" ry="3" width="91" height="10" />
        <rect x="20" y="173" rx="3" ry="3" width="162" height="10" />
      </ContentLoader> :

  <div className="list-placeholder">
        <div
      className={cx(
        'list-placeholder__background',
        { 'list-placeholder__background--with-bulk-actions': hasBulkActions }
      )} />

        <ContentLoader
      height={130}
      width={700}
      speed={1.5}
      primaryColor="rgb(232, 236, 240, 0.75)"
      secondaryColor="rgb(232, 236, 240, 0.2)"
      preserveAspectRatio="xMinYMid meet"
      className={LIST_PLACEHOLDER}>

          {hasBulkActions ? <rect x="0" y="55" rx="4" ry="4" width="20" height="20" /> : null}
          <rect x={getCalculatedXCoord(22, { shouldAdjust: hasBulkActions })} y="20" rx="6" ry="6" width="90" height="90" />
          <rect x={getCalculatedXCoord(150, { shouldAdjust: hasBulkActions })} y="28" rx="3" ry="3" width="380" height="10" />
          <rect x={getCalculatedXCoord(150, { shouldAdjust: hasBulkActions })} y="48" rx="3" ry="3" width="530" height="10" />
          <rect x={getCalculatedXCoord(150, { shouldAdjust: hasBulkActions })} y="68" rx="3" ry="3" width="200" height="10" />
          <rect x={getCalculatedXCoord(150, { shouldAdjust: hasBulkActions })} y="88" rx="3" ry="3" width="450" height="10" />
        </ContentLoader>
      </div>}

  </>;


export default Placeholder;